import React, { useState, useEffect } from 'react'
import { Container } from '../../components/Container'
import { CircularProgress } from '@material-ui/core'
import Plot from 'react-plotly.js'
import { KPIController } from '../../hooks/useKPI'

export const Lori = ({ KPIController }: { KPIController: KPIController }) => {
    const [plotWidth, setPlotWidth] = useState(0)
    const [plotHeight, setPlotHeight] = useState(0)
    useEffect(() => {
        KPIController.getLoriKpiData()
    }, [])

    // set the plot size
    useEffect(() => {
        const updateDimensions = () => {
            // Get the container element and calculate dimensions
            const container = document.querySelector('.plot-container')
            if (container) {
                // Subtracting 20px from each dimension for padding
                setPlotWidth(container.clientWidth - 20)
                setPlotHeight(container.clientHeight - 20)
            }
        }
        // Initial calculation
        updateDimensions()

        // Add resize listener
        window.addEventListener('resize', updateDimensions)

        // Cleanup
        return () => window.removeEventListener('resize', updateDimensions)
    }, [])

    const calculateMonthlyGrowth = (monthData: {
        x: string[]
        y: number[]
    }) => {
        const growthText = new Array(monthData.x.length).fill('')

        monthData.y.forEach((value, index) => {
            // Skip the first month since we can't calculate growth for it
            if (index === 0) return

            const currentValue = value
            const prevValue = monthData.y[index - 1]

            // Calculate month-over-month growth percentage
            if (prevValue !== 0) {
                const growth = ((currentValue - prevValue) / prevValue) * 100
                growthText[index] = `${growth.toFixed(1)}%`
            }
        })

        return growthText
    }

    return (
        <Container
            style={{
                flex: 1,
                flexDirection: 'column',
                height: 'calc(100vh - 200px)',
            }}
            className="plot-container"
        >
            {/* plot */}
            <Container
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {KPIController.loriKpiData ? (
                    <Plot
                        data={[
                            {
                                x: KPIController.loriKpiData.apartment.x,
                                y: KPIController.loriKpiData.apartment.y,
                                text: calculateMonthlyGrowth(
                                    KPIController.loriKpiData.apartment,
                                ),
                                textposition: 'outside' as const,
                                textfont: {
                                    size: 18,
                                    color: 'black',
                                },
                                type: 'bar' as const,
                                name: 'Apartment',
                                hovertemplate: '%{y:,.0f}<extra></extra>',
                            },
                            {
                                x: KPIController.loriKpiData.vendor.x,
                                y: KPIController.loriKpiData.vendor.y,
                                text: calculateMonthlyGrowth(
                                    KPIController.loriKpiData.vendor,
                                ),
                                textposition: 'outside' as const,
                                textfont: {
                                    size: 18,
                                    color: 'black',
                                },
                                type: 'bar' as const,
                                name: 'Vendor',
                                hovertemplate: '%{y:,.0f}<extra></extra>',
                            },
                        ]}
                        layout={{
                            width: plotWidth,
                            height: plotHeight,
                            title: { text: 'Lori Messages By Type' },
                            margin: { t: 50, b: 50, l: 50, r: 50 },
                        }}
                        useResizeHandler={true}
                        style={{ width: '100%', height: '100%' }}
                    />
                ) : (
                    <Container
                        style={{
                            flex: 1,
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress />
                    </Container>
                )}
            </Container>
        </Container>
    )
}
